// Static content for the website, taken from the html-design.
// Each export here is what an API response will replace later (locations, pricing, FAQs...).

export const APP_IOS = 'https://apps.apple.com/in/app/paddlersbox/id6755813434';
export const APP_ANDROID = 'https://play.google.com/store/apps/details?id=com.osagiancanoes.customer';

export const HERO_VIDEO = 'assets/videos/HeaderBG-optimized.mp4';

export const COUNTRY_COLOR = {Sweden: '#0B72C9', Denmark: '#E4003C'};
// Colours for countries not listed above, taken in turn (all have a gradient in GRAD).
export const EXTRA_COUNTRY_COLORS = ['#2E9B3F', '#96298E', '#F47B20'];

// `key` is the id of the section the nav item scrolls to.
export const NAV = [
    {key: 'top', label: 'Home', color: '#E4003C', icon: 'home'},
    {key: 'how', label: 'How it works', color: '#0B72C9', icon: 'zap'},
    {key: 'loc', label: 'Locations', color: '#2E9B3F', icon: 'pin'},
    {key: 'price', label: 'Pricing', color: '#FFCE00', icon: 'euro'},
    {key: 'safety', label: 'Safety', color: '#F47B20', icon: 'shield'},
    {key: 'contact', label: 'Contact', color: '#96298E', icon: 'mail'}
];

// Inner screen area of the App Store screenshots, so they can be shown inside our own phone frame.
export const SCREEN = {width: '132.51%', left: '-16.43%', top: '-55.02%', ratio: '566/1036'};

export const APP_SHOTS = [
    {src: 'assets/app/screen-01.png', alt: 'Paddlers Box app opening screen', label: 'Open the app'},
    {src: 'assets/app/screen-06.png', alt: 'Map of boxes and boats on the water', label: 'Find a box'},
    {src: 'assets/app/screen-03.png', alt: 'Choosing party size, canoe and buoyancy aids', label: 'Pick your gear'},
    {src: 'assets/app/screen-05.png', alt: 'Booking details with Unlock Now', label: 'Unlock the box'}
];

// Shown on a location card when the box has neither a video nor an image uploaded in the admin.
export const SPOT_DUMMY_VIDEO = 'assets/videos/HeaderBG-optimized.mp4';

// Country ids used by the ocagian API (location.country_id).
export const COUNTRY_BY_ID = {215: 'Sweden', 60: 'Denmark'};


export const PHOTO = {
    hero: 'assets/location/ulvo.jpg',
    gear: 'assets/location/ulvo.jpg',
    safety: 'assets/location/torne.jpg',
    contact: 'assets/location/hedehusene.jpg',
    banner: 'assets/location/alshult.jpg',
    step: 'assets/location/alvesta.jpg'
};

export const GEAR_COLORS = ['#FFCE00', '#E4003C', '#0B72C9', '#2E9B3F', '#96298E', '#F47B20'];
export const GEAR_DUMMY_VIDEO = 'assets/videos/HeaderBG-optimized.mp4';

// Items marked `numbered` take their colour from their place among the numbered items.
const GEAR_ITEMS = [
    {
        name: 'Canoes', note: 'Two and three seaters, stable and family friendly.',
        more: 'Our canoes are wide and steady, easy to get in and out of from the jetty. Pick a two seater for a couple or a three seater for a small family.'
    },
    {
        name: 'Paddles', note: 'In two sizes, 138cm and 150cm.',
        more: 'Shorter paddles suit children and smaller adults; longer ones suit taller paddlers. Try both on land before you push off.'
    },
    {
        name: 'Buoyancy aid', note: 'One size.',
        more: 'Adjust the straps so it sits snug and cannot be pulled over your head. Wear it zipped up the whole time you are on the water.'
    },
    {
        name: 'GPS', note: 'Tracking of equipment.',
        more: 'Each canoe carries a small tracker so we always know where our equipment is. It does not record anything about you.'
    },
    {
        name: 'Canoe-wagon', note: 'We have wagons ready for you.',
        more: 'Use the wagon to roll the canoe from the box down to the water, and back again when you are done.'
    },
    {
        name: 'Clothing', note: 'Dress for the weather, plus a spare layer.', numbered: true,
        more: 'Quick-drying layers, a warm top and a rain jacket. Pack a full change of clothes in a waterproof bag.'
    },
    {
        name: 'Tent', note: 'For overnight trips.', numbered: true,
        more: 'A light tent that packs small. Check the campsite rules for the lake before you set up.'
    },
    {
        name: 'Personal equipment', note: 'Sleeping bag, toiletries and medicine.', numbered: true,
        more: 'Bring what you need for your own comfort: sleeping bag and mat, sun cream, insect spray and any personal medicine.'
    },
    {
        name: 'Food', note: 'Enough for the trip, plus extra.', numbered: true,
        more: 'Plan simple meals that are easy to cook, and pack snacks and water you can reach while paddling.'
    },
    {
        name: 'Cooking equipment', note: 'Stove, pot and cutlery.', numbered: true,
        more: 'A small camping stove, a pot, a mug and cutlery for each person. Wash up away from the water.'
    },
    {
        name: 'Fire equipment', note: 'Matches or a lighter, kept dry.', numbered: true,
        more: 'Keep matches or a lighter in a dry bag. Only light fires where it is allowed, and put them out fully.'
    },
    {
        name: 'Map', note: 'A paper map of the lake.', numbered: true,
        more: 'Phones run out of battery. A paper map in a waterproof case always works.'
    },
    {
        name: 'Electronics', note: 'Phone, power bank and torch.', numbered: true,
        more: 'Keep your phone charged and in a waterproof pouch. A power bank and a head torch are worth the space.'
    }
];

let gearCount = 0;
export const GEAR = GEAR_ITEMS.map((item, i) => ({
    video: GEAR_DUMMY_VIDEO, ...item,
    pos: item.numbered ? gearCount++ : i
}));

// Steps 1–3 show app screens inside a small phone; step 4 shows a photo.
export const STEPS = [
    {
        num: '01', color: '#FFCE00', title: 'Pick a box on the map',
        body: 'Every location shows what gear is inside and what is free right now.',
        shot: 'assets/app/screen-06.png', shotAlt: 'Paddlers Box app: map of nearby boxes'
    },
    {
        num: '02', color: '#E4003C', title: 'Book your window',
        body: 'Choose a start time and a duration, then confirm the booking in the app.',
        shot: 'assets/app/screen-03.png', shotAlt: 'Paddlers Box app: choosing party size, canoe and buoyancy aids'
    },
    {
        num: '03', color: '#0B72C9', title: 'Scan the QR code',
        body: 'Tap Unlock Now in your booking and scan the code on the box. The smart lock releases at your start time.',
        shot: 'assets/app/screen-05.png', shotAlt: 'Paddlers Box app: booking details with Unlock Now'
    },
    {
        num: '04', color: '#2E9B3F', title: 'Return and lock up',
        body: 'Rinse the gear, put it back the way you found it, close the lid. That is the checkout.',
        photo: true, shotAlt: 'Paddler back at the jetty, stowing the gear'
    }
];

export const HERO_STEPS = [
    {label: 'Book', color: '#FFCE00', icon: 'cal'},
    {label: 'Scan', color: '#2E9B3F', icon: 'qr'},
    {label: 'Paddle', color: '#0B72C9', icon: 'wave'}
];

export const FEATS = [
    {color: '#96298E', icon: 'vest', title: 'Buoyancy aids included', sub: 'One size, in every box'},
    {color: '#2E9B3F', icon: 'qr', title: 'Smart lock access', sub: 'Scan to open, no key handover'},
    {color: '#F47B20', icon: 'clock', title: 'Open 24/7', sub: 'Dawn paddle or midnight sun'},
    {color: '#0B72C9', icon: 'zap', title: 'No paperwork', sub: 'No queue, no key handover'}
];

export const WHYS = [
    {
        color: '#96298E', icon: 'clock', title: '24/7 access',
        body: 'Book any time of day or night. Booking does not keep office hours. Unlimited booking from hours to months.'
    },
    {
        color: '#2E9B3F', icon: 'lock', title: 'Smart lock',
        body: 'Secure, app-issued codes that work even when the signal does not. Only Bluetooth is needed.'
    },
    {color: '#E4003C', icon: 'vest', title: 'Safety first', body: 'Buoyancy aids and a safety card in every single box.'},
    {color: '#E4003C', icon: 'leaf', title: 'Eco friendly', body: 'Shared gear, no engines, no vans shuttling boats around the lake.'}
];

export const APP_FEATS = [
    'Find the boxes nearest to you',
    'Book a slot in seconds',
    'Manage your bookings in one place',
    'Scan to unlock, offline too',
    'Live availability before you drive'
];

export const SAFETY_ROWS = [
    {color: '#E4003C', text: 'Wear your buoyancy aid the whole time, not just when it feels rough.'},
    {color: '#F47B20', text: 'Check wind and weather. Offshore wind is what gets people into trouble.'},
    {color: '#0B72C9', text: 'Tell someone your route and your return time.'},
    {color: '#2E9B3F', text: 'Keep your phone in a waterproof pouch, charged, within reach.'},
    {color: '#96298E', text: 'Stay out of shipping lanes and respect local no-paddle zones.'}
];

export const SAFETY_FACTS = [
    {color: '#0B72C9', icon: 'users', title: 'Minimum age', body: '18 to book. Under-16s paddle with an adult in the same boat.'},
    {color: '#2E9B3F', icon: 'wave', title: 'Swimming', body: 'You shall be able to swim 100 m in light clothing.'},
    {color: '#E4003C', icon: 'shield', title: 'Alcohol', body: 'Same rules as driving. Do not paddle after drinking.'},
    {color: '#F47B20', icon: 'box', title: 'Servicing', body: 'Every box is inspected regularly and after any reported fault.'}
];

export const FAQS = [
    {
        q: 'How does Paddlers Box work?',
        a: 'Find a box on the map, book a window in the app, then scan the QR code on the box to release the smart lock at your start time. Everything you need is inside.'
    },
    {q: 'What equipment is included?', a: 'A canoe, paddles, buoyancy aids, a GPS tracking device and a canoe-wagon.'},
    {
        q: 'How do I unlock the box?',
        a: 'Open your booking and tap Unlock Now. Scan the QR code on the box using the app. An active internet connection and Bluetooth must be enabled to unlock the device. Offline operation is not supported. Access will be available from your booking start time.'
    },
    {
        q: 'What if I need help?',
        a: 'Call the support number printed inside the lid, {phone}, or email {email}. We answer daily, 07:00–21:00 CET in the opening season, and 24/7 by email out of season.'
    },
    {q: 'Do I need experience?', a: 'No. The canoes are wide, stable and hard to tip. Every box has a short safety card inside the lid.'},
    {q: 'What if the box will not open?', a: 'Call the number on the lid. Support answers during daylight hours and will get you on the water.'},
    {q: 'Can children come along?', a: 'Yes, with an adult in the same boat. Buoyancy aids are in every box.'},
    {q: 'What about bad weather?', a: 'If wind or storm warnings close a location, the app tells you before your start time.'}
];

export const PLANS = [
    {
        color: '#FFCE00', icon: 'clock', term: '1 hour', price: '€14', note: 'A quick loop of the bay.',
        items: ['Canoe', 'Paddles and buoyancy aids', 'GPS tracking device', 'Canoe-wagon']
    },
    {
        color: '#E4003C', icon: 'wave', term: '3 hours', price: '€29', note: 'Enough for a proper outing.', dark: true, badge: true,
        items: ['Canoe', 'Paddles and buoyancy aids', 'GPS tracking device', 'Canoe-wagon']
    },
    {
        color: '#0B72C9', icon: 'sun', term: 'Full day', price: '€49', note: 'Sunrise to sunset, one box.',
        items: ['Canoe', 'All gear included', 'Swap between boxes on request']
    }
];

export const EXTRAS = [
    {
        color: '#E4003C', title: 'Running late', body: 'Tell support from the app and we will sort the slot out.',
        more: 'Open your booking in the app and message support as soon as you know. If the canoe is free after your slot we can extend it; if not, we will help you rebook.'
    },
    {
        color: '#0B72C9', title: 'Groups of 6+', body: 'More than 5 canoes needed, from one location? Write to us for a quote.',
        more: 'Tell us the location, the date, how many canoes you need and for how long. We will check what is free and send you a quote for the whole group.'
    },
    {
        color: '#2E9B3F', title: 'Damage', body: 'Normal wear is on us. Report anything broken in the app.',
        more: 'Scratches and everyday wear are part of renting a canoe. If something breaks or goes missing, report it in the app before you lock the box, with a photo if you can.'
    }
];

// Must match WEBSITE_CONTACT_TOPICS in the ocagian API config, which rejects any other topic.
export const CONTACT_TOPICS = [
    'A booking I already have',
    "A box that won't open",
    'Group or event booking',
    'Hosting a box at my site',
    'Something else'
];

export const CONTACT_CARDS = [
    {
        color: '#0B72C9', icon: 'mail', title: 'Support',
        body: '{email} · {phone}, or our local service member. Their phone number is listed with each location on this page.',
        note: 'Available daily 07:00–21:00 CET in the opening season. 24/7 by email out of season.'
    },
    {
        color: '#2E9B3F', icon: 'box', title: 'Host a box',
        body: 'Own a jetty, campsite or hotel by the water? We install and service the box; you take a share of every booking.'
    }
];

// Contact details and social links, managed under Settings in the admin (GET /settings).
// These values are shown until the API answers, and kept if it fails or leaves a field empty.
export const DEFAULT_SETTINGS = {
    email: 'info@paddlersbox.com',
    phone_number: '+45 20 10 02 63',
    address: '',
    facebook_link: '',
    insta_link: '',
    youtube_link: '',
    twitter_link: ''
};

// `setting` is the settings column holding the link; icons without a link are hidden.
export const SOCIALS = [
    {label: 'Facebook', color: '#0B72C9', icon: 'facebook', setting: 'facebook_link'},
    {label: 'Instagram', color: '#96298E', icon: 'instagram', setting: 'insta_link'},
    {label: 'YouTube', color: '#E4003C', icon: 'youtube', setting: 'youtube_link'},
    {label: 'X (Twitter)', color: '#2E9B3F', icon: 'x', setting: 'twitter_link'}
];
